import { MouseEvent } from "react";
import { navList } from "./navInfo";
import styles from "./Sidebar.module.scss";

type Props = {
  isShow: boolean;
  close: () => void;
};

export const Sidebar = ({ isShow, close }: Props) => {
  const handleOverlayClick = (e: MouseEvent) => {
    e.stopPropagation();
    close();
  };
  return (
    <div className={`${styles.sidebarWrapper} ${isShow ? "show" : ""}`}>
      <div className={`${styles.overlay}`} onClick={handleOverlayClick}></div>
      <div className={`${styles.sidebar} h-full overflow-y-auto`}>
        <div
          className={`${styles.logoWrapper} flex items-center content-center w-full`}
        >
          <a
            title="New Reg Private Number Plates"
            className="h-full overflow-hidden"
          >
            <h2 className="mt-20">Number Plates</h2>
          </a>
        </div>
        <ul className={`${styles.menuList}`}>
          {navList.map((nav) => {
            return (
              <li key={nav.text}>
                <a
                  href={nav?.href}
                  title={nav.title}
                  className="text-left flex overflow-hidden"
                >
                  <i
                    className="material-icons"
                    aria-hidden="true"
                    data-icon={nav.icon}
                  ></i>
                  {nav.text}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
